<template>
    <div id="contenedor-principal" class="container-fluid">
        <div id="encabezados">
            <h1>CREACIÓN DE REPORTE CÉDULAS DE NOTIFICADOR</h1>
        </div>
        <div id="secciones" class="row">
            <div id="seccion-filtros" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-3 pt-4">
                <FiltrosDeBusqueda class="area"
                        :elementosAConservar= "elementosAConservar"
                        :elementosAOmitir= "elementosAOmitir"
                        :posicionHorizontal="true"
                        :catalogos="filtrosDeBusqueda.catalogos" 
                        :conSwitchHabilitacion="true" 
                        :ejecutaLaFuncion="evtObtenerCedulasParaResultado" 
                        :filtrosEstablecidos="filtrosDeBusqueda.filtrosEstablecidos"
                        :tituloDeBusqueda="'Paso 1: Busque las cédulas.'"
                        v-on:AccionEnSwitchDeFiltros="evtAccionEnSwitchDeFiltros"
                        v-on:cambioTipoDeCedula="evtCambioTipoCedula"
                        v-on:cambioTipoNotificador="evtCambioTipoNotificador"
                        v-on:cambioTipoDeDocumento="evtCambioTipoDocumento"
                        v-on:cambioDeArea="evtCambioJuzgado"
                        :accionCancelar="filtrosDeBusqueda.objCancelarFiltros"
                        :ref="filtrosDeBusqueda.REF_FB"
                        :key="'KFBVR' + filtrosDeBusqueda.contRender"></FiltrosDeBusqueda>
            </div>
            <div id="seccion-acciones" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-3 pt-4">
                <div id="titulo-tabla-busqueda">
                  <div class="d-flex justify-content-center">
                    <i class="fas fa-clipboard-list mr-sm-2 texto-ajustable"></i>
                    <div class="align-content-center">
                      <h5 class="texto-ajustable">Listado de cédulas encontradas</h5>
                    </div>
                  </div>
                </div>
                <div class="area container-fluid">
                    <div class="row d-felx align-items-center">
                        <div v-if="reporte.cedulas.filter(c => c.enviar).length > 0 || tablaCedulasSolicitud.cedulas.length > 0" class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pr-3 pt-4">
                            <button @click="evtGenerarReporte" type="button" class="btn btn-light texto-ajustable-btn"><i class="fas fa-file"></i>&nbsp;&nbsp;Crear Reporte</button>
                        </div>
                        <div v-if="reporte.cedulas.filter(c => c.enviar).length > 0 || tablaCedulasSolicitud.cedulas.length > 0" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3 pt-4">
                            <div id="acciones-solicitud-reporte" class="form-inline justify-content-start">
                                <button @click="evtAgregarCedulasASolicitud" type="button" class="btn btn-primary texto-ajustable-btn"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Agregar cédulas a solicitud de reporte</button>
                                <button @click="evtMostrarCedulasParaReporte" id="btn-visualizar-cedulas-reporte" type="button" class="btn-sm btn-primary texto-ajustable-btn ml-2"><i class="fas fa-eye"></i></button>
                                <!-- <button @click="evtLimpiarSolicitudDeCedulas" type="button" class="btn-sm btn-primary texto-ajustable-btn ml-2"><i class="fas fa-undo"></i></button> -->
                            </div>
                        </div>
                        <div :class="[(reporte.cedulas.filter(c => c.enviar).length < 1 && tablaCedulasSolicitud.cedulas.length < 1) ? 'col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3 pt-4' : 'col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-3 pt-4']">
                            <div id="inputs-filtro-memoria" class="form-inline justify-content-end">
                                <h6 for="f-busqueda" class="mr-sm-2">Buscar:</h6>
                                <input v-model="tablaResultadosBusqueda.filtroBusqueda" type="text" id="f-busqueda" placeholder="Buscar en todas las columnas" class="form-control"/>
                            </div>
                        </div>
                    </div>
                    <CTablaGenericaCedulas class="table-responsive mt-4"
                        :idDelInput="tablaResultadosBusqueda.ID_TABLA_CEDULAS_ENCONTRADAS"
                        :encabezadosColumnas="tablaResultadosBusqueda.encabezadosColumnas"
                        :accionesEnTabla="tablaResultadosBusqueda.tablaAcciones"
                        :listaDeCedulas="tablaResultadosBusqueda.cedulasMemoria"
                        :conResponsive="true"
                        :ref="tablaResultadosBusqueda.REF_TABLA_CEDULAS"
                        v-on:elementosSeleccionados="evtObtenerCedulasSeleccionadas"
                        :key="'KTablaCedulasReporteNotificador' + tablaResultadosBusqueda.contRender"></CTablaGenericaCedulas>
                </div>
            </div>
        </div>
        <!-- MODAL SOLICIUD DE CEDULAS PARA REPORTE -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="solicitud-cedulas-reporte-notificador">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Cédulas seleccionadas para reporte</h5>
                        <button id="btn-cerrar-solicitud-cedulas-reporte-notificador" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <h6>*Revisa la información antes de generar el reporte&nbsp;&nbsp;
                            <i id="accion-eliminar-solicitudes" @click="tablaCedulasSolicitud.cedulas = []" class="fas fa-trash"></i></h6>
                        <CTablaGenericaCedulas class="table-responsive mt-1"
                            :idDelInput="tablaCedulasSolicitud.ID_TABLA_CEDULAS_ENCONTRADAS"
                            :encabezadosColumnas="tablaCedulasSolicitud.encabezadosColumnas"
                            :accionesEnTabla="tablaCedulasSolicitud.tablaAcciones"
                            :listaDeCedulas="tablaCedulasSolicitud.cedulas"
                            :conResponsive="true"
                            v-on:accionFuncionEliminar="evtRemoverCedulaDeSolicitud"
                            :ref="tablaCedulasSolicitud.REF_TABLA_CEDULAS"
                            :key="'KTablaCedulasReporteNotificadorsolicitud' + tablaCedulasSolicitud.contRender"></CTablaGenericaCedulas>
                    </div>             
                </div>
            </div>
        </div>
         <!-- MODAL CON VISUALIZADOR DE REPORTE -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="visualizador-reporte-notificador">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Reporte generado</h5>
                        <button id="btn-cerrar-visualizador-reporte-notificador" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <PDFDocument 
                            :url="visualizadorDelReporte.url" 
                            :ArchivoAConvertir="visualizadorDelReporte.archivoDeReporte"
                            :EsBase64="EsBase64"
                            :height="visualizadorDelReporte.height"
                            :key="'VDRCDN' + visualizadorDelReporte.contRender" />
                    </div>             
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import sistemas from '@/../static/js/sistemas'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'
import PDFDocument from '@/../src/components/Comunes/PDFDocument'
import { campoEsValido, convertirCadenaAMayusculas, areasAFiltrarParaDireccion } from "../../Comun/Funciones/validaciones.js"

export default {
    components: {
        PDFDocument: PDFDocument,
        FiltrosDeBusqueda: sistemas.SINOJ.FiltrosDeBusqueda,
        CTablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas
    },
    data() {
        return {
            EsBase64:{},
            areasAFiltrarParaDireccion,
            elementosAConservar: {},
            elementosAOmitir: {},
            enumeraciones,
            cedulasBD: [],
            filtrosDeBusqueda: {
                catalogos: [
                    { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Area_VRCN' },
                    { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoDocumento_VRCN' },
                    { catalogoId: enumeraciones.catalogos.Consecutivo, idDelInput: 'filtroDeBusqueda_Consecutivo_VRCN' },
                    { catalogoId: enumeraciones.sinoj.catalogos.TiposDeCedula, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoCedula_VRCN' },
                    { catalogoId: enumeraciones.sinoj.catalogos.Notificadores, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Notificador_VRCN' },
                    { catalogoId: 'filtroPersona', etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_PersonaANotificar_VRCN' },
                    { catalogoId: enumeraciones.catalogos.NumeroExtra, idDelInput: 'f-nExtra-VRCN' },
                    { catalogoId: enumeraciones.catalogos.FechaDeInicio },
                    { catalogoId: enumeraciones.catalogos.FechaFinal }
                ],
                filtrosEstablecidos: {},
                objCancelarFiltros: null,
                REF_FB: 'REFFBVRN',
                contRender: 0
            },
            tipoCedulaId: -1,
            filtrosDeBusquedaSecciones: {
                expediente: true,
                cedula: true,
                fechas: true
            },
            tablaResultadosBusqueda: {
                ID_TABLA_CEDULAS_ENCONTRADAS: 'tablaCEReporteDeNotificador',
                REF_TABLA_CEDULAS: 'REFtablaCEReporteDeNotificador',
                encabezadosColumnas: ['Folio', 'Juzgado', 'Tipo de documento','Domicilio','Persona a notificar', 'Consecutivo', 'Tipo de cédula', 'Resultado',''],
                tablaAcciones: { motrarAcciones: true, check: true, eliminar: false, detalles: false },
                cedulas: [],
                contRender: 0,
                cedulasMemoria: [],
                filtroBusqueda: null
            },
            tablaCedulasSolicitud: {
                ID_TABLA_CEDULAS_ENCONTRADAS: 'tablaCEReporteDeNotificadorSolicitud',
                REF_TABLA_CEDULAS: 'REFtablaCEReporteDeNotificadorSolicitud',
                encabezadosColumnas: ['Folio', 'Juzgado', 'Tipo de documento','Domicilio','Persona a notificar', 'Consecutivo', 'Tipo de cédula', 'Resultado',''],
                tablaAcciones: { motrarAcciones: true, check: false, eliminar: true, detalles: false },
                cedulas: [],
                contRender: 0
            },
            notificador: {
                tipoNotificadorId: -1
            },
            reporte: {
                cedulas: []
            },
            visualizadorDelReporte: {
                url: null,
                height: '500px',
                archivoDeReporte: null,
                contRender: 0
            }
        }
    },
    created(){
        // Filtros de areas.
        let filtrosAreas = areasAFiltrarParaDireccion({ areaDireccion: this.$store.state.Login_Usuario.Area.AreaId, conDireccion: true });

        if(filtrosAreas.elementosAOmitir != undefined || filtrosAreas.elementosAOmitir != null)
            this.elementosAOmitir.areas = filtrosAreas.elementosAOmitir;
        
        if(filtrosAreas.elementosAConservar != undefined || filtrosAreas.elementosAConservar != null)
            this.elementosAConservar.areas = filtrosAreas.elementosAConservar;
    },
    methods: {
        evtLimpiarSolicitudDeCedulas: function() {
            if(this.tablaCedulasSolicitud.cedulas.length > 0) {
                this.tablaCedulasSolicitud.cedulas = [];
                this.tablaResultadosBusqueda.contRender ++;
            }
            else {
                comun.mensajeDeAlerta('La lista de cedulas para la solicitud del reporte se encuentra vacia.')
            }
        },
        evtRemoverCedulaDeSolicitud: function(evento) {
            const CEDULA_SELECCIONADA = evento.target.getAttribute('id');
            const CEDULA = CEDULA_SELECCIONADA.split('-');
            const INDEX_ID = (CEDULA.length - 1);
            const ID_CEDULA = CEDULA[INDEX_ID];
            this.tablaCedulasSolicitud.cedulas = this.tablaCedulasSolicitud.cedulas.filter(c => c.Folio != ID_CEDULA);
        },
        evtGenerarReporte: function() {
            if(this.tablaCedulasSolicitud.cedulas.length > 0) {
                this.obtenerArchivoDeReporteGenerado();
            }
            else {
                comun.mensajeDeAlerta('<i class="fas fa-exclamation-circle"></i> <strong>No se encuentran cedulas en la lista para la solicitud del reporte</strong><br> paso 1: marca las cedulas en la tabla de la seccion lista de cedulas encontradas. <br> paso 2: dar click en el boton <strong>Agregar cedulas a solicitud de reporte</strong>. <br> paso 3 (opcional): Revisa las cedulas en la lista para la solicitud del reporte. <br> paso 4: dar click en el boton <strong>Crear Reporte</strong>.');
            }
        },
        obtenerArchivoDeReporteGenerado: function() {
            // let peticion = new FormData();
            // peticion.append('EsPrueba',false);
            // peticion.append('SolicitudesDeReportes',JSON.stringify(this.tablaCedulasSolicitud.cedulas));
            // peticion.append('notificador',this.notificador.tipoNotificadorId)
            console.log("ENTRA A API DE REPORTE")
            let peticion = {
                EsPrueba:false,
                SolicitudesDeReportes:JSON.stringify(this.tablaCedulasSolicitud.cedulas),
                notificador:this.notificador.tipoNotificadorId
            }
             const SERVIDOR = api.conexion;
            const METODO_API_OBTENER = api.SINOJ.sistema.reportes.reporteDeNotificador.ObtenerReporteDeNotificador;
            let urlApi = SERVIDOR + METODO_API_OBTENER;
            let peticionArchivos = true;
            this.visualizarReporte = false;
            console.log("ENTRA peticion url::",urlApi)
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticion, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            const ARCHIVO_DESCARGADO = respuesta.data.ArchivoBase64;
                            console.log("respuesta::::::::::::::::",respuesta.data)
                            //if(ARCHIVO_DESCARGADO != null && ARCHIVO_DESCARGADO.byteLength > 0) {
                             
                                this.EsBase64={
                                  esBase64:true,
                                  archivoBase64:respuesta.data.ArchivoBase64
                                  }
                                // this.visualizadorDelReporte.archivoDeReporte = new File([ARCHIVO_DESCARGADO], 'ReporteCedulasDeNotificador', { type: 'application/pdf' });
                                this.visualizadorDelReporte.contRender ++;
                                $('#visualizador-reporte-notificador').modal('show');
                           // }
                            //else
                              //  comun.mensajeDeAlerta('No se encontro información con los parámetros  ingresados en las solicitudes de reporte');
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        evtAgregarCedulasASolicitud: function() {
            moment.locale('es');
            let agregoCedulaNuevaASolicitud = false;
            if(this.reporte.cedulas.filter(cs => cs.enviar).length < 1) {
                comun.mensajeDeAlerta('No se encuentran cedulas seleccionadas');
                return;
            }
            this.reporte.cedulas
            .filter(cs => cs.enviar)
            .forEach(c => {
                //console.log('cMemoria::',this.tablaResultadosBusqueda.cedulasMemoria);
                //console.log('cedula::',c)
                let cedulaSelEstaEnlistado = this.tablaResultadosBusqueda.cedulasMemoria.some(cm => cm.Folio == c.folio);
                let fueAgregadaASolicitud = this.tablaCedulasSolicitud.cedulas.some(csl => csl.Folio == c.folio);
                //console.log('cedulaSelEstaEnlistado::' + cedulaSelEstaEnlistado + ' fueAgregadaASolicitud::' + fueAgregadaASolicitud);
                if(cedulaSelEstaEnlistado && !fueAgregadaASolicitud) {
                    let cedulaSolicitud = { ...this.tablaResultadosBusqueda.cedulasMemoria.find(cm => cm.Folio == c.folio) };
                    cedulaSolicitud.FechaDeAudiencia = "Sin fecha";
                    let cedulaDBOBJ = this.cedulasBD.find(cBD => cBD.CedulaId == c.folio)
                    let acuerdoPrincipal = (this.campoRequeridoEsValido(cedulaDBOBJ) && this.campoRequeridoEsValido(cedulaDBOBJ.Acuerdos)) ? cedulaDBOBJ.Acuerdos.find(a => a.EsPrincipal) : null;
                    if(this.campoRequeridoEsValido(acuerdoPrincipal)) {
                        cedulaSolicitud.FechaDeAudiencia = moment(acuerdoPrincipal.FechaDeAudiencia).format('DD MMMM YYYY hh:mm a');
                    }
                    console.log(cedulaSolicitud)
                    this.tablaCedulasSolicitud.cedulas.push(cedulaSolicitud);
                    agregoCedulaNuevaASolicitud = true;
                }
            });

            if(!agregoCedulaNuevaASolicitud)
                comun.mensajeDeAlerta('las cédulas seleccionadas ya se encuentran en la lista de solicitudes');
            else
                comun.mensajeDeAlerta('las cédulas seleccionas se agregaron correctamente a la solicitud del reporte');
        },
        evtMostrarCedulasParaReporte: function() {
            $('#solicitud-cedulas-reporte-notificador').modal('show');
        },
        evtObtenerCedulasSeleccionadas: function(evento) {
            const CEDULAS_TABLA = evento;
           // console.log('cedSel::',evento);
            this.reporte.cedulas = CEDULAS_TABLA.filter(c => c.enviar);
        },
        evtAccionEnSwitchDeFiltros: function(accionRealizada) {
            switch(accionRealizada.tipoDeFiltro) {
                case 'Expediente':
                    this.filtrosDeBusquedaSecciones.expediente = accionRealizada.habilitar;
                    break;
                case 'Cedula':
                    this.filtrosDeBusquedaSecciones.cedula = accionRealizada.habilitar;
                    break;
                case 'Fechas':
                    this.filtrosDeBusquedaSecciones.fechas = accionRealizada.habilitar;
                    break;
                default:
                    break;
            };
        },
        evtObtenerCedulasParaReporte: async function() {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SINOJ.sistema.reportes.reporteDeNotificador.ObtenerCedulasReporteDeNotificador;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionAPI = { 
                    JuzgadoId: this.campoRequeridoEsValido(this.$refs[this.filtrosDeBusqueda.REF_FB].parametros_Area.areaId) && this.filtrosDeBusquedaSecciones.expediente ? this.$refs[this.filtrosDeBusqueda.REF_FB].parametros_Area.areaId : null,
                    TipoDeDocumentoId: this.campoRequeridoEsValido(this.$refs[this.filtrosDeBusqueda.REF_FB].parametros_TipoDocumento.tipoDocumentoId) && this.filtrosDeBusquedaSecciones.expediente ? this.$refs[this.filtrosDeBusqueda.REF_FB].parametros_TipoDocumento.tipoDocumentoId : null,
                    Consecutivo: this.campoRequeridoEsValido(parseInt(this.$refs[this.filtrosDeBusqueda.REF_FB].numeroExtra)) && this.filtrosDeBusquedaSecciones.expediente ? parseInt(this.$refs[this.filtrosDeBusqueda.REF_FB].numeroExtra) : null,
                    NumeroDeDocumento: this.campoRequeridoEsValido(this.$refs[this.filtrosDeBusqueda.REF_FB].consecutivo) && this.filtrosDeBusquedaSecciones.expediente ? this.$refs[this.filtrosDeBusqueda.REF_FB].consecutivo : null,
                    TipoDeCedulaId: this.campoRequeridoEsValido(this.tipoCedulaId) && this.filtrosDeBusquedaSecciones.cedula ? this.tipoCedulaId : null,
                    NotificadorId: this.campoRequeridoEsValido(this.notificador.tipoNotificadorId) ? this.notificador.tipoNotificadorId : null,
                    PersonaANotificar: this.campoRequeridoEsValido(this.$refs[this.filtrosDeBusqueda.REF_FB].personaANotificar) ? this.$refs[this.filtrosDeBusqueda.REF_FB].personaANotificar : null,
                    FechaInicial: this.campoRequeridoEsValido(this.$refs[this.filtrosDeBusqueda.REF_FB].fechaInicial) && this.filtrosDeBusquedaSecciones.fechas ? this.$refs[this.filtrosDeBusqueda.REF_FB].fechaInicial : null,
                    FechaFinal: this.campoRequeridoEsValido(this.$refs[this.filtrosDeBusqueda.REF_FB].fechaFinal) && this.filtrosDeBusquedaSecciones.fechas ? this.$refs[this.filtrosDeBusqueda.REF_FB].fechaFinal : null,
                    esPrueba: false 
                };
                /* console.log('filtros::',this.filtrosDeBusquedaSecciones.cedula);
                console.log('peticion::',peticionAPI); */
                let peticionArchivos = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                this.cargandoCedulas = true;
                const RESPUESTA_OBTENER_CEDULAS = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_OBTENER_CEDULAS.data;
                let { SiHayError, Error, Satisfactorio,  Cedulas } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(true);
                    console.log(mensajeError);
                } 
                else {
                  //  console.log('RespuestaBusqueda::',DATOS_RESPUESTA);
                    if(Cedulas != null && Cedulas.length > 0) {
                        this.cedulasBD = Cedulas;
                        this.tablaResultadosBusqueda.cedulas = this.inicilaizarListaCedulasParaTabla(Cedulas);
                        this.tablaResultadosBusqueda.cedulasMemoria = this.tablaResultadosBusqueda.cedulas;
                        this.tablaResultadosBusqueda.contRender ++;
                        this.$nextTick(() => {
                            this.reporte.cedulas.filter(c => c.enviar).forEach(cedulaSeleccionada => {
                                let cedulaEstaEnResultados = this.tablaResultadosBusqueda.cedulasMemoria.some(c => c.Folio == cedulaSeleccionada.folio);
                               // console.log('estaEnResultados::',cedulaEstaEnResultados);
                                if(cedulaEstaEnResultados)
                                    this.$refs[this.tablaResultadosBusqueda.REF_TABLA_CEDULAS].seleccionDeCedulaComponentePadre(cedulaSeleccionada.idCheck);
                            });
                            this.reporte.cedulas = this.$refs[this.tablaResultadosBusqueda.REF_TABLA_CEDULAS].cedulasAEnviar;
                        });

                        // se agregan eventos para el filtrado en memoria
                        $("#inputs-filtro-memoria input").on("change paste keyup", (e) => {
                            if(this.tablaResultadosBusqueda.cedulas.length > 0) {
                                this.filtrarCedulasTabla(e);
                            }
                        });
                    }
                    else {
                        this.tablaResultadosBusqueda.cedulas = [];
                        this.tablaResultadosBusqueda.cedulasMemoria = [];
                        this.reporte.cedulas = [];
                        this.tablaResultadosBusqueda.contRender ++;
                        comun.mensajeDeAlerta(Satisfactorio);
                    }
                }
          }
          catch(excepcion) {
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
          }
        },
        filtrarCedulasTabla: function(e) {
            // filtra por columnas y nivel de prioridad
            this.tablaResultadosBusqueda.cedulasMemoria = this.tablaResultadosBusqueda.cedulas
            .filter(c => {
                return Object.values(c).some(valorColumna => this.predicateFiltradoPorSimilitud(valorColumna, this.tablaResultadosBusqueda.filtroBusqueda));
            });
            this.$nextTick(() => {
                this.reporte.cedulas.filter(c => c.enviar).forEach(cedulaSeleccionada => {
                    let cedulaEstaEnResultados = this.tablaResultadosBusqueda.cedulasMemoria.some(c => c.Folio == cedulaSeleccionada.folio);
                    // console.log('estaEnResultados::',cedulaEstaEnResultados);
                    if(cedulaEstaEnResultados)
                        this.$refs[this.tablaResultadosBusqueda.REF_TABLA_CEDULAS].seleccionDeCedulaComponentePadre(cedulaSeleccionada.idCheck);
                });
                this.reporte.cedulas = this.$refs[this.tablaResultadosBusqueda.REF_TABLA_CEDULAS].cedulasAEnviar;
            });
        },
        predicateFiltradoPorSimilitud: function(elementoAEvaluar,compararCon) { 
            if(this.campoRequeridoEsValido(compararCon)) {
            if(elementoAEvaluar.toString().toUpperCase().startsWith(compararCon.toString().toUpperCase()))
                return true;
            else
                return false;
            }
            else
                return true;
        },
        inicilaizarListaCedulasParaTabla: function(cedulas) {
            let cedulasFormatoTabla = [];
            cedulasFormatoTabla = cedulas.map(cedula => {
                let cedulaObj = this.objetoCedulaAObjetoTabla(cedula);
                return cedulaObj;
            });
            return cedulasFormatoTabla;
        },
        objetoCedulaAObjetoTabla: function(cedula) { debugger
            let cedulaObjTabla = {};
            cedulaObjTabla.Folio = cedula.CedulaId;
            cedulaObjTabla.Juzgado = 'Sin juzgado';
            if(this.campoRequeridoEsValido(cedula.Expediente)) { 
                cedulaObjTabla.Juzgado = (cedula.Expediente.Juzgado != null ) ? cedula.Expediente.Juzgado.Nombre : 'Sin juzgado';
                cedulaObjTabla.TipoDocumento = (cedula.Expediente.TipoDocumento != null) ? cedula.Expediente.TipoDocumento.Nombre : 'Sin documento';
            }
            cedulaObjTabla.Domicilio = 'Sin Domicilio';
            cedulaObjTabla.PersonaANotificar = 'Sin Persona a Notificar';
            if(this.campoRequeridoEsValido(cedula.PersonasANotificar)) {
                if(cedula.PersonasANotificar[0].Domicilios != null && cedula.PersonasANotificar[0].Domicilios.length > 0) {
                    const DOMICILIO_OBJ = cedula.PersonasANotificar[0].Domicilios[0];
                    let infAdicionalNumExt = (this.campoRequeridoEsValido(DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior)) ? ` ${ DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior }` : '';
                    let numInterior = (this.campoRequeridoEsValido(DOMICILIO_OBJ.NumeroInterior)) ? `int ${ DOMICILIO_OBJ.NumeroInterior.toString().trim() }` : '';
                    if(this.campoRequeridoEsValido(DOMICILIO_OBJ.Fraccionamiento)) {
                        cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ DOMICILIO_OBJ.Fraccionamiento.Nombre }, ${ DOMICILIO_OBJ.Fraccionamiento.Municipio.Nombre }`;
                    }
                    else {
                        /* 
                            para los casos de domicilios con fraccionamiento que no pertenece al catalogo de fraccionamientos, se guarda la informacion el un solo campo (008FraccionamientoFueraDeCatalogo => FraccionamientoFueraDeCatalogo)
                            con el siguiente formato NOMBRE_FRACCIONAMIENTO, NOMBRE_MUNICIPIO, si se modifica posteriormenete este formato se tendra que reemplazar esta 
                            logica.
                            */
                        let fraccionamientoCompuesto = DOMICILIO_OBJ.FraccionamientoFueraDeCatalogo.split(',');
                        let nombreFraccionamiento = fraccionamientoCompuesto[0];
                        let nombreMunicipio = fraccionamientoCompuesto[1];
                        cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ nombreFraccionamiento }, ${ nombreMunicipio }`;
                    }

                    /* const DOMICILIO_OBJ = cedula.PersonaANotificar.Domicilios[0];
                    let infAdicionalNumExt = (this.campoRequeridoEsValido(DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior)) ? ` ${ DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior }` : '';
                    let numInterior = (this.campoRequeridoEsValido(DOMICILIO_OBJ.NumeroInterior)) ? `int ${ DOMICILIO_OBJ.NumeroInterior }` : '';
                    cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ DOMICILIO_OBJ.Fraccionamiento.Nombre }, ${ DOMICILIO_OBJ.Fraccionamiento.Municipio.Nombre }`; */
                }
                
                if(this.campoRequeridoEsValido(cedula.PersonasANotificar[0].DatosGenerales)) {
                    const { Fisica, Moral } = cedula.PersonasANotificar[0].DatosGenerales;
                    /*if(this.campoRequeridoEsValido(Fisica))
                        cedulaObjTabla.PersonaANotificar = `${ Fisica.Nombre.toUpperCase().trim() } ${ Fisica.ApellidoPaterno.toUpperCase().trim() }${ (this.campoRequeridoEsValido(Fisica.ApellidoMaterno)) ? (" " + Fisica.ApellidoMaterno.toUpperCase().trim()) : "" }`; 
                    else if(this.campoRequeridoEsValido(Moral))
                        cedulaObjTabla.PersonaANotificar = `${ Moral.Nombre.trim() }`; */
                    if(this.campoRequeridoEsValido(Fisica))
                        /* cedulaObjTabla.PersonaANotificar = `${ Fisica.Nombre.toUpperCase().trim() } ${ Fisica.ApellidoPaterno.toUpperCase().trim() }${ (this.campoRequeridoEsValido(Fisica.ApellidoMaterno)) ? (" " + Fisica.ApellidoMaterno.toUpperCase().trim()) : "" }`;  */
                        cedulaObjTabla.PersonaANotificar = `${ convertirCadenaAMayusculas({ cadena: Fisica.Nombre }) } ${ convertirCadenaAMayusculas({ cadena: Fisica.ApellidoPaterno }) }${ (campoEsValido({ campoAValidar: Fisica.ApellidoMaterno })) ? (" " + Fisica.ApellidoMaterno.toUpperCase().trim()) : "" }`; 
                    else if(this.campoRequeridoEsValido(Moral))
                        /* cedulaObjTabla.PersonaANotificar = `${ Moral.Nombre.trim() }`;  */
                        cedulaObjTabla.PersonaANotificar = `${ convertirCadenaAMayusculas({ cadena: Moral.Nombre }) }`; 
                }
            }
            cedulaObjTabla.Consecutivo = 'Sin consecutivo';
            if(this.campoRequeridoEsValido(cedula.Expediente)) { 
                cedulaObjTabla.Consecutivo = cedula.Expediente.NumeroDeDocumento;
            }
            cedulaObjTabla.TipoCedula = this.campoRequeridoEsValido(cedula.TipoCedula.Nombre) ? cedula.TipoCedula.Nombre.trim() : 'Sin tipo de cedula.';
            cedulaObjTabla.Resultado = (cedula.Resultado != null) ? cedula.Resultado.TipoResultado.Nombre : 'Sin resultado';
            return cedulaObjTabla;
        },
        evtObtenerCedulasParaResultado: async function() {
            comun.SeEstaCargandoInformacion(true);
            await Promise.resolve(this.evtObtenerCedulasParaReporte());
            comun.SeEstaCargandoInformacion(false);
        },
        evtCambioTipoCedula: function(evento) { 
            this.tipoCedulaId = parseInt(evento.target.value);
        },
        evtCambioTipoNotificador: function(evento, obj) { debugger
            this.notificador.tipoNotificadorId = parseInt(evento.target.value);
        },
        evtCambioTipoDocumento: function(evento) {

        },
        evtCambioJuzgado: function(evento) {

        },
        asignarValoresUsuarioNotificador: async function() { 
          try {
            this.filtrosDeBusqueda.contRender ++;
            const SERVIDOR = api.conexion;
            const METODO_API_OBTENER = api.SINOJ.sistema.consultas.consultaDireccion.ObtenerDatosDeNotificador;
            let urlApi = SERVIDOR + METODO_API_OBTENER;
            let peticionAPI = { esPrueba: false };
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            this.cargandoCedulas = true;
            const PETICION_NOTIFICADOR = await axios.post(urlApi, peticionAPI, headerPeticion);
            const DATOS_PETICION = await PETICION_NOTIFICADOR.data;
            let { SiHayError, Error, Notificador } = DATOS_PETICION;
            if (SiHayError) {
                let mensajeError = Error.Mensaje;
                console.log(mensajeError);
            } 
            else {
                this.notificador.tipoNotificadorId = Notificador.NotificadorId;
                this.$refs[this.filtrosDeBusqueda.REF_FB].parametros_Notificadores.esInformativo = this.campoRequeridoEsValido(Notificador.NotificadorId) ? true : false;
                this.$refs[this.filtrosDeBusqueda.REF_FB].parametros_Notificadores.valorDefinido = Notificador.NotificadorId;
                this.$refs[this.filtrosDeBusqueda.REF_FB].parametros_Notificadores.key = 'CFTNVRCN' + this.filtrosDeBusqueda.contRender;
            }
          }
          catch(excepcion) {
              console.log(excepcion);
              comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
          }
      },
      campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'array' || campo instanceof Array) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo.length > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      }
    },
    async mounted() {
        comun.SeEstaCargandoInformacion(true);
        this.$nextTick(() => {
            this.$refs[this.filtrosDeBusqueda.REF_FB].evtDeshabilitarFiltros('Fechas');
        });
        await Promise.resolve(this.asignarValoresUsuarioNotificador());
        await Promise.resolve(this.evtObtenerCedulasParaReporte());
        comun.SeEstaCargandoInformacion(false);                
    },
    watch: {
        'reporte.cedulas': function() {
            let todosLosElementosSeleccionados = (this.reporte.cedulas.filter(c => c.enviar).length == this.tablaResultadosBusqueda.cedulasMemoria.length);
            this.$refs[this.tablaResultadosBusqueda.REF_TABLA_CEDULAS].mostrarSeleccionTodoComponentePadre(todosLosElementosSeleccionados);
        }
    }
}
</script>
<style scoped>
#titulo-tabla-busqueda {
    background-color:black; 
    padding-top: 13px;
    padding-bottom: 8px;
    margin-top: 1vw;
}

.texto-ajustable {
    font-size: 1.5vw;
}

.texto-ajustable-btn {
     font-size : 1vw;
}

#f-busqueda {
    width: 23vw;
}

#acciones-solicitud-reporte .btn-sm {
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
}

#acciones-solicitud-reporte .btn {
    padding-left: 12px;
    padding-right: 12px;
    cursor: pointer;
}

#solicitud-cedulas-reporte-notificador .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#solicitud-cedulas-reporte-notificador .modal-lg {
    max-width: 60% !important;
}

.contenedor-color-negro {
    padding: 1.5em;
    background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616;
}

#accion-eliminar-solicitudes {
    cursor: pointer;
}

#visualizador-reporte-notificador .modal-lg {
    max-width: 70% !important;
}

#visualizador-reporte-notificador .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Reportes/ReportesDeNotificadores/CReporteCedulasDeNotificador.vue